import { API_CALL_ERROR } from './../../../store/action';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import { CREATE_BULK_LOCATIONS_REQUESTED, CREATE_BULK_LOCATIONS_SUCCEEDED, CREATE_LOCATION_REQUESTED, CREATE_LOCATION_SUCCEEDED } from './create.action';
import * as _ from 'lodash';
import { ApiService } from '../../../api/api.service';
import { Router } from '@angular/router';
import {FETCH_ALL_DESTINATION_REQUESTED} from "../../destination/destination.action";

function* createLocations(action) {
  // console.log(action.data);
  // const router = AppInjector.get(Router);
  // try {
  //   const api = AppInjector.get(ApiService);
  //   let result = yield api.location.bulkCreate(action.data).toPromise();
  //   if (result === 'org.hibernate.exception.ConstraintViolationException: could not execute statement') {
  //     yield put({ type: API_CALL_ERROR, message: result });
  //   } else {
  //     yield put({ type: CREATE_BULK_LOCATIONS_SUCCEEDED, res: result });
  //     router.navigate(['location']);
  //   }
  // } catch (e) {
  //   yield put({ type: API_CALL_ERROR, error: e });
  // }
}

function* watchCreateBulkLocationRequest() {
  yield takeEvery(CREATE_BULK_LOCATIONS_REQUESTED, createLocations);
}

function* createLocation(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.location.create(action.data).toPromise();
    yield put({ type: FETCH_ALL_DESTINATION_REQUESTED, com: 'LOCATION_LIST_COMPONENT', refresh: true });
    yield put({ type: CREATE_LOCATION_SUCCEEDED, data: result.data });
    router.navigate([action.redirect ? action.redirect : 'location']);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCreateLocationRequest() {
  yield takeEvery(CREATE_LOCATION_REQUESTED, createLocation);
}

export default [watchCreateBulkLocationRequest, watchCreateLocationRequest];
